module.exports = __webpack_public_path__ + "img/attachment-chat.25538bc0.svg";